













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditProfilExclusion.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'

@Component({
  name: 'ReadProfilExclusion',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadProfilExclusion extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean

  get profilExclusion(){
    return this.$store.myGetters.profilExclusion
  } 

  created(){
    this.$store.myActions.ADM_PROFIL_EXCLUSION_ENSURE()
  }

  edit() { (this.$refs.edit as Edit).edit(this.flux) }

}
